import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutGrid, Package, Mail, Settings, LogOut, FileText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

const items = [
    { to: "/admin/dashboard", label: "Overview", icon: LayoutGrid, tid: "nav-dashboard" },
    { to: "/admin/products", label: "Products", icon: Package, tid: "nav-products-admin" },
    { to: "/admin/inquiries", label: "Inquiries", icon: Mail, tid: "nav-inquiries" },
    { to: "/admin/content", label: "Site Content", icon: FileText, tid: "nav-content" },
    { to: "/admin/settings", label: "Settings", icon: Settings, tid: "nav-settings" },
];

const AdminLayout = () => {
    const { logout, user } = useAuth();
    const nav = useNavigate();

    const doLogout = async () => {
        await logout();
        nav("/admin/login", { replace: true });
    };

    return (
        <div className="min-h-screen grid grid-cols-1 md:grid-cols-[260px_1fr] bg-white" data-testid="admin-layout">
            <aside className="border-r border-gray-200 bg-white flex flex-col">
                <div className="p-6 border-b border-gray-200">
                    <Logo className="h-9 w-auto" />
                    <div className="mt-3 overline text-red-600">Admin Console</div>
                </div>
                <nav className="flex-1 p-4 space-y-1">
                    {items.map((i) => (
                        <NavLink
                            key={i.to}
                            to={i.to}
                            data-testid={i.tid}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-4 py-3 font-mono text-[11px] uppercase tracking-[0.18em] transition-colors ${
                                    isActive
                                        ? "bg-gray-900 text-white"
                                        : "text-gray-700 hover:bg-gray-100"
                                }`
                            }
                        >
                            <i.icon size={16} strokeWidth={1.75} />
                            {i.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="p-4 border-t border-gray-200 space-y-3">
                    <div className="px-4 text-xs text-gray-500" data-testid="admin-user-email">{user?.email}</div>
                    <button
                        onClick={doLogout}
                        className="w-full flex items-center justify-between px-4 py-3 font-mono text-[11px] uppercase tracking-[0.18em] text-gray-700 hover:bg-gray-100"
                        data-testid="admin-logout"
                    >
                        Log out <LogOut size={14} />
                    </button>
                </div>
            </aside>
            <main className="bg-gray-50 min-h-screen">
                <div className="p-6 md:p-10">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default AdminLayout;
